import { render, staticRenderFns } from "./ImagesBasic.vue?vue&type=template&id=148a8b55&"
import script from "./ImagesBasic.vue?vue&type=script&lang=js&"
export * from "./ImagesBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports